import React, { useEffect, useState } from "react";
import db from "../assets/db/main-db.json";
import { Button } from "react-bootstrap";
import { addMainInventory } from "../network/api/firebaseApi";
function EditRawGoods({
  product,
  onValidateAndSubmit,
  isRaw,
  userPermissions,
  onClose,
}) {
  const [allVariants, setAllVariants] = useState([]);
  const [image, setSelectedImage] = useState("");
  const [isEditable, setIsEditable] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setIsLoading] = useState(false);

  console.log(`Admin ${isAdmin}  and isEditable ${isRaw}`);

  const handleFinalSubmit = async () => {
    // IMEI validation function
    const isValidIMEI = (imei) => /^\d{15}$/.test(imei);

    if (!isValidIMEI(formData.imei_1)) {
      alert("IMEI 1 must be exactly 15 digits.");
      setIsLoading(false);
      return;
    }

    if (formData.imei_2 && !isValidIMEI(formData.imei_2)) {
      alert("IMEI 2 must be exactly 15 digits.");
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    const { quality, category, comment, ...filteredFormData } = formData; // Remove quality from formData

    const combinedData = { ...filteredFormData, ...adminData };

    console.log(combinedData);
    const result = await addMainInventory(product.uid, combinedData);
    if (result.error) {
      alert(result.error);
    } else {
      alert(result.success);
      onClose(); // Close dialog only on success
    }
  };

  useEffect(() => {
    if (userPermissions.includes("Add Repaired Inventory")) {
      setIsEditable(false);
    }
    if (userPermissions.includes("Add Main Inventory")) {
      setIsAdmin(true);
      setFormData((prevData) => ({
        brand: product.brand,
        model: product.model,
        category: product.category,
        variant: product.variant,
        quality: product.quality,
        notes: product.notes,
        qcBy:product.qcBy,
        qcDescription:product.qcDescription,
        qcPrice:product.qcPrice,
        comment: product.comment,
        imei_1: product.imei_1,
        imei_2: product.imei_2,
      }));
    }
    console.log(isAdmin);
  }, [userPermissions, product]);
  const [formData, setFormData] = useState({
    brand: product.brand,
    model: product.model,
    category: product.category,
    variant: "",
    quality: "",
    notes: product.notes,
    qcBy:"",
    qcPrice:"",
    qcDescription:"",
    comment: "",
    imei_1: "",
    imei_2: "",
  });
  const [adminData, setAdminData] = useState({
    condition: "",
    distributorPrice: "",
    retailerPrice: "",
  });
  const handleAdminChange = (e) => {
    setAdminData({ ...adminData, [e.target.name]: e.target.value });
  };
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    // Fetch the variants and image URL for the selected brand and model
    const allModels =
      db.brands.find((brand) => brand.name === product.brand)?.models || [];
    const model = allModels.find((model) => model.name === product.model);

    setAllVariants(model?.variants || []);
    setSelectedImage(model?.imageUrl || "");
  }, [product.brand, product.model]); // Dependency array

  const handleSubmit = async () => {
    if (onValidateAndSubmit) {
      setIsSubmitting(true); // Set submitting state to true
      await onValidateAndSubmit({ formData: formData, uid: product.uid }); // Assuming this returns a promise
      setIsSubmitting(false); // Set submitting state to false after the operation completes
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  if (!isAdmin && !isRaw) {
    return <> "Not Accessible"</>;
  }
  return (
    <div className="flex justify-center items-center">
      <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-lg">
        <h2 className="text-2xl font-semibold mb-6">Update Details</h2>

        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <select
                name="brand"
                disabled={isEditable}
                className="w-full p-2 border border-gray-300 rounded-md cursor-not-allowed"
              >
                <option>{product.brand}</option>
              </select>

              <select
                name="model"
                required
                disabled={isEditable}
                className="w-full p-2 mt-4 border border-gray-300 rounded-md cursor-not-allowed"
              >
                <option>{product.model}</option>
              </select>
              <select
                name="variant"
                onChange={handleChange}
                disabled={isEditable}
                className="w-full p-2 mt-4 border border-gray-300 rounded-md"
              >
                {isAdmin ? (
                  isRaw ? (
                    <>
                      <option value="">Select Variant</option>
                      {allVariants.map((variant) => (
                        <option key={variant.variant} value={variant.variant}>
                          {variant.variant}
                        </option>
                      ))}
                    </>
                  ) : (
                    <option>{formData.variant}</option>
                  )
                ) : (
                  <>
                    <option value="">Select Variant</option>
                    {allVariants.map((variant) => (
                      <option key={variant.variant} value={variant.variant}>
                        {variant.variant}
                      </option>
                    ))}
                  </>
                )}
              </select>
              <select
                name="quality"
                onChange={handleChange}
                disabled={isEditable}
                className="w-full p-2 mt-4 border border-gray-300 rounded-md"
              >
                {isAdmin && !isRaw && <option>{formData.quality}</option>}
                <option key={null} value="">
                  Select Quality
                </option>
                <option key={1} value="1">
                  1
                </option>
                <option key={2} value="2">
                  2
                </option>
                <option key={3} value="3">
                  3
                </option>
              </select>

              {isAdmin && (
                <select
                  name="condition"
                  required
                  onChange={handleAdminChange}
                  disabled={isEditable && !isAdmin}
                  className="w-full p-2 mt-4 border border-gray-300 rounded-md"
                >
                  <option key={null} value="">
                    Select Condition
                  </option>
                  <option key={1} value="Silver">
                    Silver
                  </option>
                  <option key={2} value="Gold">
                    Gold
                  </option>
                  <option key={3} value="Platinum">
                    Platinum
                  </option>
                </select>
              )}
            </div>
            {/* Image Preview */}

            {image ? (
              <div className="flex justify-center items-center bg-gray-100 rounded-lg">
                <img src={image} alt="Preview" className="" />
              </div>
            ) : (
              <div className="flex justify-center items-center bg-gray-300 rounded-lg">
                <p className="text-bkack font-bold animate-bounce">
                  ❌No Image❌
                </p>
              </div>
            )}
          </div>

          {/* Inputs */}
          <div className="space-y-4">
            {/* <input
              type="number"
              name="quantity"
              placeholder="Quantity"
              disabled
              value={product.quantity}
              className="w-full p-2 border border-gray-300 rounded-md cursor-not-allowed"
            /> */}

            <input
              type="text"
              name="qcBy"
              value={formData.qcBy}
              onChange={handleChange}
              placeholder="Engineer Name"
              disabled={isEditable}
              required
              onWheel={(e) => e.target.blur()}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
            <input
              type="number"
              name="qcPrice"
              placeholder="QC Cost"
              onChange={handleChange}
              required
              value={formData.qcPrice}
              disabled={isEditable}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
            <textarea
              type="text"
              name="qcDescription"
              value={formData.qcDescription}
              onChange={handleChange}
              placeholder="QC Description"
              disabled={isEditable}
              required
              
              onWheel={(e) => e.target.blur()}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
            <input
              type="text"
              name="imei_1"
              onChange={handleChange}
              placeholder="IMEI No.1"
              maxLength={15}
              value={formData.imei_1}
              onWheel={(e) => e.target.blur()}
              disabled={isEditable}
              onInput={(e) =>
                (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
              } // Ensures only numbers
              className="w-full p-2 border border-gray-300 rounded-md"
            />

            <input
              type="text"
              name="imei_2"
              onChange={handleChange}
              disabled={isEditable}
              value={formData.imei_2}
              maxLength={15}
              placeholder="IMEI No.2"
              onWheel={(e) => e.target.blur()}
              onInput={(e) =>
                (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
              } // Ensures only numbers
              className="w-full p-2 border border-gray-300 rounded-md"
            />
            <input
              type="text"
              name="notes"
              value={product.notes || "empty"}
              disabled={isEditable}
              onWheel={(e) => e.target.blur()}
              className="w-full p-2 border border-gray-300 rounded-md"
            />

            {isAdmin && !isRaw && (
              <>
                <input
                  type="number"
                  name="mrp"
                  placeholder="MRP"
                  onChange={handleAdminChange}
                  disabled={isEditable}
                  className="w-full p-2 border border-gray-300 rounded-md"
                />
                <input
                  type="number"
                  name="distributorPrice"
                  placeholder="Distributor Price"
                  onChange={handleAdminChange}
                  disabled={isEditable}
                  className="w-full p-2 border border-gray-300 rounded-md"
                />

                <input
                  type="number"
                  name="retailerPrice"
                  placeholder="Retailer Price"
                  onChange={handleAdminChange}
                  disabled={isEditable}
                  className="w-full p-2 border border-gray-300 rounded-md"
                />
              </>
            )}
            {userPermissions.includes("Add Repaired Inventory") && (
              <>
                <Button
                  onClick={isAdmin ? handleFinalSubmit : handleSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Updating..." : "Update"}
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditRawGoods;
